module.exports = __webpack_public_path__ + "img/thumbs-down.f0a9848d.svg";